
import { defineStore } from 'pinia'
import { AppStore } from '@/types'

export default () => defineStore('app', {
  state: ():AppStore => ({
    // 侧边栏menu
    sideBarMenu: [],
    // 侧边栏缩放
    collapsed: false,
    // 侧边栏展示
    siderBarVisible: true,
    // 顶部tabs显隐
    topTabsVisible: false,
    // 顶部tabs
    tabsList: null,
    // 当前顶部栏激活的tab
    activeTab: '',
    // 切换微应用loading
    loading: false,
    // 主应用路由
    globalHistory: null
  }),
  getters: {
    // collapsed: (state) => state.collapsed,
  },
  actions: {
    setCollapsed() {
      this.collapsed = !this.collapsed
    },
    // 是否显示侧边栏
    setSiderBarVisible(show: boolean) {
      this.siderBarVisible = show
    },
    // 点击路由 添加当前tabs数据
    setTabItem(payload: any) {
      if (!this.tabsList) this.tabsList = []
      const tab = this.tabsList.find((tab: { key: any }) => tab.key === payload.key)
      if (!Array.isArray(payload) && payload) {
        if (!tab) {
          payload && this.tabsList.push(payload)
          this.activeTab = this.tabsList.slice(-1)[0]?.key || ''
        } else this.activeTab = payload.key || ''
      }
    },
    // topTabs正在添加或删减tab
    changeTabList(payload: any) {
      this.tabsList = payload
    },
    // 设置当前tab激活item
    setActiveTab(payload: string) {
      this.activeTab = payload
    },
    // 设置当前tab激活item
    setGlobalHistory(payload: any) {
      this.globalHistory = payload
    },
    // 全局loading
    setLoading(payload: boolean) {
      this.loading = payload
      console.log(`[Store] setLoading(${payload}) 调用栈:`, new Error().stack?.split('\n').slice(1, 4).join('\n'))
    }
  }
})
